import React from 'react';

const SchoolBenefits = () => {
  const benefits = [
    {
      id: 1,
      title: "Accompagnement enseignants",
      description: "Formation complète et support continu pour les enseignants, avec des ressources pédagogiques adaptées et un accompagnement personnalisé.",
      icon: "👩‍🏫",
      color: "bg-purple-3",
      textColor: "text-purple-1"
    },
    {
      id: 2,
      title: "Élèves motivés et créatifs",
      description: "Stimulez la créativité et l'engagement des élèves avec des projets concrets qui développent leurs compétences techniques et leur confiance en soi.",
      icon: "👩‍🎓",
      color: "bg-light-2",
      textColor: "text-blue-1"
    },
    {
      id: 3,
      title: "Kits pédagogiques inclus",
      description: "Matériel complet et adapté à l'âge des enfants, avec tous les composants nécessaires pour réaliser les projets sans frais supplémentaires.",
      icon: "🛠️",
      color: "bg-light-6",
      textColor: "text-red-2"
    },
    {
      id: 4,
      title: "Outils de suivi et d'évaluation",
      description: "Tableaux de bord intuitifs pour suivre les progrès de chaque élève et évaluer l'acquisition des compétences du programme.",
      icon: "📈",
      color: "bg-green-1 bg-opacity-20",
      textColor: "text-green-1"
    },
    {
      id: 5,
      title: "Accès à une communauté internationale",
      description: "Échangez avec d'autres écoles et experts à travers le monde, partagez vos projets et inspirez-vous des meilleures pratiques.",
      icon: "🌍",
      color: "bg-blue-1 bg-opacity-20",
      textColor: "text-blue-1"
    }
  ];

  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-dark-1 mb-4 font-sans">
            Avantages pour les écoles
          </h2>
          <p className="text-light-1 text-lg max-w-3xl mx-auto font-sans">
            Découvrez pourquoi des centaines d'établissements nous font confiance
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div 
              key={benefit.id} 
              className={`rounded-2xl p-6 transition-all duration-300 ${benefit.color} border border-white`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="flex items-center mb-4">
                <span className="text-3xl mr-4">{benefit.icon}</span>
                <h3 className={`text-lg font-bold font-sans ${benefit.textColor}`}>
                  {benefit.title}
                </h3>
              </div>
              <p className="text-light-1 font-sans text-normal leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Témoignages et statistiques */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="text-4xl font-bold text-purple-1 mb-2 font-sans">250+</div>
            <p className="text-light-1 font-sans">Écoles partenaires</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-1 mb-2 font-sans">98%</div>
            <p className="text-light-1 font-sans">De satisfaction</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-1 mb-2 font-sans">15k+</div>
            <p className="text-light-1 font-sans">Élèves formés</p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default SchoolBenefits;